module.exports = __webpack_public_path__ + "static/img/youshi.dece16e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/youshi.png
// module id = 1fpR
// module chunks = 1